import React, {
  RefObject,
  useCallback,
  useEffect,
  useRef,
  useState,
} from 'react';
import { getMessageList } from '../../../api';
import { IMessageItem } from '../../../model/api-modules';
import { MessageCenter } from '../message-center';
import HeaderMessage from '../../../assets/svg/header-message.svg';
import { PermissionMessageContent } from './permissiom-message';
import { eventBus, getFormatDateTime, LanguageType } from '../../../lib';
import { isMobile } from '../../../lib/mobile';

export type MessageComponentRef = {
  refreshMessages: () => Promise<void>; // 导出方法名
};

interface IProps {
  readonly lang?: LanguageType | null;
}

export const ItemMessageComponent = (props: IProps) => {
  const messageRef: RefObject<HTMLDivElement> = React.createRef();
  const [show, setShow] = useState<boolean>(false);
  const [list, setList] = useState<ReadonlyArray<IMessageItem>>([]);
  const [unreadMessageList, setUnreadMessageList] = useState<
    ReadonlyArray<IMessageItem>
  >([]);
  const timerRef = useRef<NodeJS.Timeout | null>(null);
  const isRequestPendingRef = useRef<boolean>(false);

  const initEvent = () => {
    document.addEventListener('click', onClickHandle);
    return () => {
      document.removeEventListener('click', onClickHandle);
    };
  };
  const getList = async () => {
    const res = await getMessageList();
    const msgList = res?.list || [];
    // console.log('头部MessageList----msgList:',msgList);
    const noReadList: IMessageItem[] = [];
    msgList.forEach((item) => {
      if (!item.ReadInfo) {
        noReadList.push(item);
      }
    });
    setUnreadMessageList(noReadList);
    setList(msgList);
  };

  const refreshMessages = async () => {
    try {
      await getList();
    } catch (error) {
      console.error('刷新失败:', error);
    }
  };

  useEffect(() => {
    getList();
    const handleRefresh = () => {
      refreshMessages();
    };

    eventBus.on('refreshMessages', handleRefresh);
    return () => {
      eventBus.off('refreshMessages', handleRefresh);
    };
  }, []);

  // useCallback 来确保 getListWithCheck 回调函数的稳定性。即使组件重新渲染，也能保证回调函数的引用不会发生变化。
  const getListWithCheck = useCallback(async () => {
    if (!isRequestPendingRef.current) {
      isRequestPendingRef.current = true;
      const targetDate = new Date('2024-11-06');
      const filteredList = unreadMessageList?.filter((message) => {
        const times = getFormatDateTime(message.CreateTime);
        const createTime = new Date(times);
        return createTime.getTime() > targetDate.getTime(); // 时间戳比较
      });
      // console.log('2024-11-06未读的消息：',filteredList);
      // console.log('unreadMessageList.length===0：',unreadMessageList.length===0);
      if (unreadMessageList.length === 0 || filteredList.length > 0) {
        await getList();
      }
      isRequestPendingRef.current = false;
    }
  }, [unreadMessageList]);

  useEffect(() => {
    initEvent();
    getListWithCheck();

    if (!timerRef.current) {
      timerRef.current = setInterval(() => {
        // 10秒轮询一次消息
        getListWithCheck();
      }, 10000);
    }

    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
        timerRef.current = null;
      }
    };
  }, [getListWithCheck, unreadMessageList]);
  const onClickHandle = (e: MouseEvent) => {
    const target = e.target as Node;
    const messageSelect = messageRef.current;
    if (target.contains(messageSelect) || messageSelect?.contains(target)) {
      setShow(true);
    } else {
      setShow(false);
    }
  };

  const messagePermission = () => {
    return (
      <PermissionMessageContent
        messageList={list}
        unreadMessageList={unreadMessageList}
        getUnreadMessageList={getList}
      />
    );
  };

  const onClickIcon = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    e.stopPropagation();
    if (!show) {
      getList();
    }
    setShow(!show);
  };

  const renderContent = () => {
    return (
      <div ref={messageRef}>
        <MessageCenter
          messageList={list}
          unreadMessageList={unreadMessageList}
          getUnreadMessageList={getList}
          lang={props.lang}
        />
      </div>
    );
  };

  const renderRedTip = () => {
    if (unreadMessageList.length) {
      return <label className="red-dot"></label>;
    }
    return null;
  };

  return (
    <li>
      <a className="action-item" onClick={onClickIcon}>
        <span className="action-icon">
          <img
            src={HeaderMessage}
            style={{
              width: isMobile() ? 30 : 16,
              height: isMobile() ? 30 : 16,
            }}
          />
          {renderRedTip()}
        </span>
      </a>
      {show ? renderContent() : null}
      {messagePermission()}
    </li>
  );
};
